/** Staff notification as a bell row: kind mapped to a type, listing resolved to a car label. */
export class NotificationEntry {
    id;
    type;
    read;
    createdAt;
    message;
    listingId;
    car;
    constructor(id, type, read, createdAt, message, listingId, car) {
        this.id = id;
        this.type = type;
        this.read = read;
        this.createdAt = createdAt;
        this.message = message;
        this.listingId = listingId;
        this.car = car;
    }
    static fromStaff(n, listings, readIds = new Set()) {
        const listing = n.refId ? listings.get(n.refId) : undefined;
        return new NotificationEntry(n.id, n.kind.includes("sale") ? "sale_request" : "appointment_request", n.read || readIds.has(n.id), n.createdAt, n.message, n.refId, listing
            ? { year: listing.year, make: listing.make, model: listing.model }
            : { year: 0, make: "", model: "" });
    }
    carTitle() {
        return `${this.car.year} ${this.car.make} ${this.car.model}`;
    }
    withRead() {
        return new NotificationEntry(this.id, this.type, true, this.createdAt, this.message, this.listingId, this.car);
    }
}
//# sourceMappingURL=NotificationEntry.js.map